import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { orderingSchema } from '~/hooks/useSortableTable';
import { z } from 'zod';

export const querySchema = z
  .object({
    search: z.string().default(''),
    competition_type_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    age_category_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
  })
  .merge(paginationSchema)
  .merge(orderingSchema);
